const namespace = 'session/'

export const SET_PROFILE = namespace + '.SET_PROFIILE'
